import moment from 'moment';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { compose, createStore, GenericStoreEnhancer } from 'redux';
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';
import sessionStorage from 'redux-persist/es/storage/session';

import { reducers } from '../../reducers';
import children from '../../routes';

function ConvertDates(obj: any) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const val = obj[prop];
      
      if (typeof val === 'object') {
        ConvertDates(val);
      }
      if (typeof val === 'string' && moment(val).isValid()) {
        obj[prop] = moment(val);
      }
    }
  }
  return obj;
}

const dateTransform = createTransform((inboundState) => inboundState, ConvertDates);

const config = {
  key: 'root',
  storage: sessionStorage,
  transforms: [dateTransform],
  // debug: true
};

const reducer = persistReducer(config, reducers);

// tslint:disable-next-line:no-string-literal
const devToolsExtension: GenericStoreEnhancer = window['devToolsExtension'] ?
  // tslint:disable-next-line:no-string-literal
  window['devToolsExtension']() : (f: any) => f;

const store = createStore(
  reducer,
  compose(
    devToolsExtension
  ) as GenericStoreEnhancer
);

const persistor = persistStore(store, undefined, () => { store.getState(); });

const basename = environmentSettings.basePath ? `${environmentSettings.basePath}` : undefined;

export default function AppContainer() {
  return (
    <PersistGate persistor={persistor}>  
      <Provider {...{ store }}>
        <Router {...{ basename, children }} />
      </Provider>
    </PersistGate>
  );
}
